<div class="container" appDnd (fileDropped)="onFileDropped($event)">
    <input type="file" #fileDropRef id="ingestFileDropRef" multiple [accept]="acceptTypes"
        (change)="fileBrowseHandler($event.target.files); fileDropRef.value = ''" />
    <mat-icon class="upload-icon">upload_file</mat-icon>
    <h3>Drag and drop file(s) here</h3>
    <h3>or</h3>
    <label for="ingestFileDropRef">Browse for File</label>
    <p class="hint">Supported types: {{acceptTypes}}</p>
    <p class="hint" *ngIf="maxUploadSizeBytes">Max size per file: {{formatBytes(maxUploadSizeBytes)}}</p>
</div>

<div class="upload-list" *ngIf="rows.length > 0">
    <div class="upload-row" *ngFor="let row of rows">
        <mat-icon class="file-icon">insert_drive_file</mat-icon>
        <div class="info">
            <div class="name-line">
                <span class="name">{{row.name}}</span>
                <span class="type-badge">{{row.typeLabel}}</span>
                <span class="size">{{formatBytes(row.sizeBytes)}}</span>
            </div>
            <mat-progress-bar
                mode="determinate"
                [value]="row.progress"
                [ngClass]="'bar-' + row.status.toLowerCase()">
            </mat-progress-bar>
            <div class="status-line" [ngClass]="row.status.toLowerCase()">
                {{row.status}}<span *ngIf="row.status === 'Uploading'"> - {{row.progress}}%</span>
                <span *ngIf="row.errorMessage"> - {{row.errorMessage}}</span>
            </div>
        </div>
        <button mat-icon-button title="Remove from list" (click)="removeRow(row)">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>
